import { Box, TextField, InputAdornment } from '@mui/material';
import { useInput, useTranslate } from 'react-admin';

interface ColorInputProps {
  source: string;
  label?: string;
  fullWidth?: boolean;
}

export const ColorInput = ({ source, label, fullWidth }: ColorInputProps) => {
  const translate = useTranslate();
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useInput({ source });

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    // Ensure it starts with #
    if (newValue && !newValue.startsWith('#')) {
      newValue = '#' + newValue;
    }
    onChange(newValue);
  };

  return (
    <TextField
      label={label ? translate(label) : undefined}
      value={value || ''}
      onChange={handleTextChange}
      error={!!error}
      helperText={error?.message}
      fullWidth={fullWidth}
      placeholder="#000000"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Box
              component="input"
              type="color"
              value={value || '#000000'}
              onChange={handleColorChange}
              sx={{
                width: 32,
                height: 32,
                border: 'none',
                borderRadius: 1,
                cursor: 'pointer',
                padding: 0,
                '&::-webkit-color-swatch-wrapper': {
                  padding: 0,
                },
                '&::-webkit-color-swatch': {
                  border: '1px solid rgba(0,0,0,0.2)',
                  borderRadius: 4,
                },
              }}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};
